import React, { useState, useEffect, useRef } from 'react';

import { isValidCron } from 'cron-validator';
import { string, func } from 'prop-types';

import { defaultSchedulers, UTCValues } from 'Utils';
/**
 *
 * @param {string} schedule - the schedule cron experssion
 * @callback onChangeScheduler - a callback when changing the cron expression
 * @returns JSX.Element
 */
function Scheduler({
  schedule,
  schedulerTimezone,
  onChangeScheduler,
  onChangeTimezone
}) {
  const [shouldOpenSchedulerCustomField, setShouldOpenSchedulerCustomField] =
    useState(false);
  const [currentSchedule, setCurrentSchedule] = useState(schedule);
  const [hasClickedCustomButton, setHasClickedCustomButton] = useState(false);
  const schedulerCustomFieldValueRef = useRef(null);

  useEffect(() => {
    if (
      hasClickedCustomButton &&
      shouldOpenSchedulerCustomField &&
      schedulerCustomFieldValueRef.current
    ) {
      schedulerCustomFieldValueRef.current.focus();
    }
  }, [shouldOpenSchedulerCustomField]);

  useEffect(() => {
    if (!Object.keys(defaultSchedulers).includes(currentSchedule)) {
      setShouldOpenSchedulerCustomField(true);
    }
  }, []);

  function handleClickOpenSchedulerCustomField(e) {
    if (currentSchedule) {
      setCurrentSchedule('');
      onChangeScheduler('');
    }
    if (e.target) {
      setShouldOpenSchedulerCustomField((prev) => !prev);
    }
    setHasClickedCustomButton((prev) => !prev);
  }

  function handleSetSchedulerValue(e) {
    setCurrentSchedule(e.target.value);
    onChangeScheduler(e.target.value);
    if (schedulerCustomFieldValueRef.current !== document.activeElement)
      setShouldOpenSchedulerCustomField(false);
  }

  function handleSetTimezone(timezone) {
    onChangeTimezone(timezone);
  }

  return (
    <div className="row sdp-mb-2" data-testid="scheduler-component">
      <div className="col-12">
        <h3>Ingests every</h3>
      </div>
      <div className="sdp-btn-group flex">
        {Object.entries(defaultSchedulers).map(([crontab, label]) => {
          return (
            <button
              key={label}
              value={crontab}
              className="sdp-btn sdp-btn--soft-outline"
              type="button"
              style={{
                background: currentSchedule === crontab ? '#306bf6' : '#F8FAF9',
                border: '1px solid rgba(0, 0, 0, 0.1)',
                color: currentSchedule === crontab ? '#ffffff' : '#7A7E85'
              }}
              onClick={handleSetSchedulerValue}
              data-testid={`scheduler-component_cronButton${
                label.split(' ')[0]
              }`}
            >
              {label}
            </button>
          );
        })}
        <button
          className="sdp-btn sdp-btn--soft-outline"
          type="button"
          style={{
            background: shouldOpenSchedulerCustomField ? '#306bf6' : '#F8FAF9',
            border: '1px solid rgba(0, 0, 0, 0.1)',
            color: shouldOpenSchedulerCustomField ? '#ffffff' : '#7A7E85'
          }}
          onClick={handleClickOpenSchedulerCustomField}
          data-testid="scheduler-component_cronButtonCustom"
        >
          Custom
        </button>
      </div>
      {schedulerTimezone ? (
        <select
          onChange={(event) => {
            handleSetTimezone(`${event.target.value}`);
          }}
          defaultValue={schedulerTimezone || '0'}
          style={{
            borderRadius: '0.3rem',
            color: '#7A7E85',
            borderColor: '#dddddd',
            backgroundColor: '#F8FAF9',
            height: '2.5rem',
            padding: '0 0.5rem',
            cursor: 'pointer'
          }}
        >
          {UTCValues.map((data) => {
            if (data.value === 0) {
              return (
                <option value={data.value} key={data.name} selected>
                  {data.name}
                </option>
              );
            }
            return (
              <option value={data.value} key={data.name}>
                {data.name}
              </option>
            );
          })}
        </select>
      ) : null}

      {shouldOpenSchedulerCustomField ? (
        <div
          className="row sdp-mb-2 mt-3 m-0"
          data-testid="scheduler-component_cronCustomBox"
        >
          <div className="col-12 sdp-p-0">
            <div
              className={`sdp-fieldset ${
                currentSchedule && !isValidCron(currentSchedule)
                  ? 'sdp-fieldset--error'
                  : ''
              }`}
            >
              <input
                ref={schedulerCustomFieldValueRef}
                type="text"
                id="scheduler-custom-field"
                className="sdp-form-input"
                value={currentSchedule}
                onChange={handleSetSchedulerValue}
                placeholder="Input a cron expression"
              />
              {currentSchedule && !isValidCron(currentSchedule) ? (
                <span className="sdp-fc--error">Invalid cron expression!</span>
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default Scheduler;

Scheduler.propTypes = {
  schedule: string,
  schedulerTimezone: string,
  onChangeScheduler: func,
  onChangeTimezone: func
};

Scheduler.defaultProps = {
  schedule: '',
  schedulerTimezone: undefined,
  onChangeScheduler: () => {},
  onChangeTimezone: () => {}
};
